import { render } from "./App.vue?vue&type=template&id=0ec7b94d"
const script = {}

import "./App.vue?vue&type=style&index=0&id=0ec7b94d&lang=scss"

import exportComponent from "/home/runner/work/LabSolver/LabSolver/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__